import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=7a5f683a&scoped=true&"
import script from "./journal.vue?vue&type=script&lang=ts&"
export * from "./journal.vue?vue&type=script&lang=ts&"
import style0 from "./journal.vue?vue&type=style&index=0&id=7a5f683a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f683a",
  null
  
)

export default component.exports